// @flow @jsx h

import { PolopolyPicture } from '@nrk/dh-feature-components'
import { h } from 'preact'
import style from './index.css'

import type { Bio } from './types'
import type { Viewport } from '../../types'

type Props = Bio & { viewport: Viewport }

function CharactedPresentationBackground (props: Props) {
  const { alt, horizontalId, viewport } = props

  // const inlineStyle = {}
  const gradientInlineStyle = {}

  if (viewport.height > -1) {
    // inlineStyle.height = `${viewport.height}px`
    gradientInlineStyle.height = `${viewport.height / 2}px`
  }

  return (
    <div className={style.characterSlideshow__background}>
      <PolopolyPicture
        horizontal={{ id: horizontalId, quality: 'high' }}
        alt={alt}
      />
      <div
        className={style.characterSlideshow__gradient}
        aria-hidden='true'
        style={gradientInlineStyle}
      />
    </div>
  )
}

export default CharactedPresentationBackground



// WEBPACK FOOTER //
// ./src/v1/components/Article/Content/CharacterPresentation/Background.js